module.exports = __webpack_public_path__ + "img/二氧化碳减排量 (1).7bf98dc3.png";